import React, { useState, useEffect, useRef, useCallback } from "react";
import { producaov2 as api } from "../../../../../services/apis";
import { isAuthAdmin } from "../../../../../services/auth";
import { Icon, Button, Loader } from "semantic-ui-react";
import { Container, Content, Title, SemanticTable } from "./styles";
import { Container as SemanticContainer, Segment } from "semantic-ui-react";
import swal from "sweetalert";
import { withRouter, Link } from "react-router-dom";
import AdminMenu from "../../../../../components/Admin/MenuDetalhes/AdminMenu";

const BannerFaq = props => {
  const [segments, setSegments] = useState([]);

  useEffect(() => {
    loadAuth();
    loadSegmentFaq();
  }, []);

  const loadAuth = async () => {
    const auth = await isAuthAdmin();

    if (!auth) {
      localStorage.setItem("redirect", `/admin/`);
      window.location.href = "/login";
      return null;
    }
  };

  const loadSegmentFaq = async () => {
    await api
      .get(`/faq-categorias`)
      .then(res => {
        setSegments(res.data);
      })
      .catch(err => {
        swal("Não foi possível carregar as categorias de tipo", err, "error");
      });
  };

  const removeFaqSegment = useCallback(
    id => {
      swal({
        title: "Tem certeza que deseja excluir este segmento?",
        text: "Esta ação é irreversível.",
        icon: "warning",
        buttons: true,
        dangerMode: true,
      })
        .then(res => {
          if (res) {
            api.delete(`/faq-categorias/${id}`).then(async res => {
              let logs = {
                local: "faq",
                texto: `Excluiu o Segmento de FAQ id=${id}`,
              };
              await api.post("system_logs", { acao: JSON.stringify(logs) });

              const newSegments = [...segments].filter(faq => faq.id !== id);
              setSegments(newSegments);
            });
          }
        })
        .catch(async error => {
          const logs = {
            local: `admin/mba/list/${id}`,
            texto: `Tentou remover o segmento de FAQ (${id}) - Erro: ${error}`,
          };
          await api.post("system_logs", {
            acao: JSON.stringify(logs),
          });
          swal("Erro ao excluir módulo", "Favor contactar TI", "error");
        });
    },
    [segments]
  );

  return (
    <>
      <Container>
        <AdminMenu />

        <Content>
          <Title>FAQs</Title>
          <Link to="/admin/faq/criar-segmento">
            <Button>Criar Segmento</Button>
          </Link>
          <SemanticTable size="big" celled>
            <SemanticTable.Header>
              <SemanticTable.Row>
                <SemanticTable.HeaderCell>ID</SemanticTable.HeaderCell>
                <SemanticTable.HeaderCell>Segmento</SemanticTable.HeaderCell>
                <SemanticTable.HeaderCell>Descrição</SemanticTable.HeaderCell>
                <SemanticTable.HeaderCell>Ações</SemanticTable.HeaderCell>
              </SemanticTable.Row>
            </SemanticTable.Header>
            {segments.length > 0 ? (
              <SemanticTable.Body>
                {segments.map((faq, index) => (
                  <SemanticTable.Row key={index}>
                    <SemanticTable.Cell>{faq.id}</SemanticTable.Cell>
                    <SemanticTable.Cell>{faq.segmento}</SemanticTable.Cell>
                    <SemanticTable.Cell>{faq.text_segmento}</SemanticTable.Cell>
                    <SemanticTable.Cell>
                      <>
                        <Button
                          icon="eye icon"
                          color="orange"
                          onClick={() => window.open(`faq/detalhes/${faq.id}`)}
                          title={`Visualizar e editar FAQs do segmento ${faq.segmento}`}
                        />

                        <Button
                          icon="edit icon"
                          color="grey"
                          onClick={() =>
                            window.open(`faq/edit-segment/${faq.id}`)
                          }
                          title={`Editar Segmento ${faq.segmento}`}
                        />

                        <Button
                          icon="trash icon"
                          color="red"
                          onClick={() => removeFaqSegment(faq.id)}
                          title={`Remover Segmento ${faq.segmento}`}
                        />
                      </>
                    </SemanticTable.Cell>
                  </SemanticTable.Row>
                ))}
              </SemanticTable.Body>
            ) : (
              <h3>Nenhuma FAQ encontrada</h3>
            )}
          </SemanticTable>
        </Content>
      </Container>
      <SemanticContainer>
        <Segment>
          Grupo Voitto <i class="copyright outline icon"></i>
          {new Date().getFullYear()}
        </Segment>
      </SemanticContainer>
    </>
  );
};

export default withRouter(BannerFaq);
